<template>
  <v-snackbar :color="color" :bottom="bottom" :top="top" :left="left" :right="right" :centered="centered" shaped v-model="snackbar">
    <v-row>
      <v-col cols="11">
        <v-alert :type="alertType">{{ message }}</v-alert></v-col
      >
      <v-col cols="1" style="text-align: center">
        <div @click="snackbar = false" style="font-size: 22px" :style="{ cursor: 'pointer' }">x</div>
      </v-col>
    </v-row>

    <!-- <v-icon color="white" class="mr-3">{{ icon }}</v-icon> -->

    <!-- <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon> -->
  </v-snackbar>
</template>

<script>
export default {
  name: "Notification",
  data: () => ({
    //
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    centered: false,
    snackbar: false,
    alertType: "success",
    icon: "",
    message: ""
  }),
  created: function () {
    this.$eventHub.$on("showError", this.showError);
    this.$eventHub.$on("showSuccess", this.showSuccess);
    this.$eventHub.$on("showInfo", this.showInfo);
    this.$eventHub.$on("hideDrawer", this.hideDrawer);
    this.$eventHub.$on("showTerminalMessage", this.showTerminalMessage);
  },
  methods: {
    hideDrawer(val) {
      this.$emit("HideDrawer", val);
    },
    showError: function (msg, ...args) {
      this.top = false;
      this.bottom = true;
      this.left = false;
      this.right = true;
      this.centered = false;

      this.alertType = "warning";
      for (const loc of args) {
        this[loc] = true;
      }

      this.color = "warning";
      this.message = msg;
      this.icon = "mdi-alert-circle-outline";
      this.snackbar = true;
    },
    showInfo: function (msg, ...args) {
      this.top = false;
      this.bottom = true;
      this.left = false;
      this.right = true;
      this.centered = false;
      this.alertType = "info";

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = "#3192FF";
      this.message = msg;
      this.icon = "mdi-information-outline";
      this.snackbar = true;
    },
    showSuccess: function (msg, ...args) {
      this.top = false;
      this.bottom = true;
      this.left = false;
      this.right = true;
      this.centered = false;
      this.alertType = "success";
      for (const loc of args) {
        this[loc] = true;
      }

      this.color = "green";
      this.message = msg;
      this.icon = "mdi-check";
      this.snackbar = true;
    },
    showTerminalMessage: function (msg, ...args) {
      this.top = true;
      this.bottom = false;
      this.left = false;
      this.right = false;
      this.centered = true;
      this.alertType = "success";
      for (const loc of args) {
        this[loc] = true;
      }

      this.color = "green";
      this.message = msg;
      this.icon = "mdi-check";
      this.snackbar = true;
    },
    snack: function (msg, color, icon, ...args) {
      this.snackbar = false;
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;
      this.centered = false;

      this.alertType = "success";

      for (const loc of args) {
        this[loc] = true;
      }

      this.message = msg;
      this.icon = icon;
      this.color = color;

      this.snackbar = true;
    }
  }
};
</script>

<style scoped>
.v-snack--bottom {
  bottom: 0px !important;
}
</style>
